<template>
	<div
		class="topDiv d-flex align-items-center"
		ref="suggestions"
		@focusout="closeDropdownOnFocusOut"
	>
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font w-40"
			>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
		>
		<div class="w-100 position-relative">
			<div
				class="overflow-x-auto customised-form-tags w-100 position-relative"
				:class="{
					showErrorClass: showError || !isvalidTag,
					'show-add-btn': showSuggestions,
				}"
			>
				<b-form-tags
					ref="tags"
					:id="id"
					:type="type"
					no-outer-focus
					remove-on-delete
					@focusin="handleFocusIn"
					@focusout="handleFocusOut"
					v-model="inputData"
					:disabled="disabled"
					@input="handleInput"
					@blur="$emit('handle-blur')"
					tabindex="0"
					:tag-validator="validateTag"
					invalid-tag-text=""
					separator=",;"
				>
				</b-form-tags>

				<div v-if="!isvalidTag" class="newInt-required-validation-font mt-1">
					Max Character Exceed 64
				</div>
			</div>
			<label
				id="hideinlaptop"
				class="selcus-floating-label"
				@click="handleFocusIn"
				:class="{
					active: inputData.length > 0 || isFocused || currentInput.length > 0,
				}"
			>
				{{ label }}
				<span v-if="mandatory" class="asterik">&nbsp;*</span>
			</label>
			<div
				ref="suggestions-dropdown"
				class="tags-mobile-suggestion"
				v-if="showSuggestions && filteredOptions.length > 0"
				style="max-height: 180px; overflow-y: auto"
				@scroll="onScroll"
			>
				<div
					v-if="skillLoading && skillScrollDir === 'up'"
					class="skill-spinner-row"
				>
					<b-spinner small variant="primary" label="Loading…"></b-spinner>
				</div>
				<!-- <div class="tags-suggestion-selected">option 1</div>
        <div class="tags-suggestion-unselected">option 2</div> -->
				<div
					class="tags-suggestion-unselected pointer"
					:class="{
						'tags-suggestion-selected highlighted':
							index === currentHighlightIndex,
					}"
					v-for="(suggestion, index) in filteredOptions"
					:key="index"
					@click.stop="selectSuggestion(suggestion)"
				>
					{{ suggestion }}
				</div>
				<div
					v-if="skillLoading && skillScrollDir === 'down'"
					class="skill-spinner-row"
				>
					<b-spinner small variant="primary" label="Loading…"></b-spinner>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FormTags",
	props: {
		disabled: Boolean,
		noLabel: Boolean,
		type: String,
		label: String,
		mandatory: Boolean,
		placeholder: String,
		id: String,
		showError: Boolean,
		suggestions: Array,
		skillLoading: Boolean,
		skillScrollDir: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},

	data() {
		return {
			inputData: [],
			showSuggestions: false,
			currentTag: "",
			isFocused: false,
			currentInput: "",
			isvalidTag: true,
			filteredOptions: [],
			emitted: false,
			pendingScrollDir: null,
			currentHighlightIndex: -1,
		};
	},
	mounted() {
		document.addEventListener("click", this.closeDropdownOnClickOutside);
		const inputField = this.$refs.tags?.$el.querySelector("input");
		if (inputField) {
			inputField.addEventListener("input", this.handleTyping);
			inputField.addEventListener("keydown", this.handleKeyPress, true);
		}
	},
	beforeDestroy() {
		document.removeEventListener("click", this.closeDropdownOnClickOutside);
		const inputField = this.$refs.tags?.$el.querySelector("input");
		if (inputField) {
			inputField.removeEventListener("input", this.handleTyping);
			inputField.removeEventListener("keydown", this.handleKeyPress, true);
		}
	},
	watch: {
		vmodel(newVal, oldVal) {
			if (!this.emitted || JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
				this.inputData = newVal;
				this.$emit("select-value", this.inputData);
				this.emitted = true;
			}
		},
		showError(val) {
			if (val == true) {
				this.checkValid(this.inputData);
			}
		},
		filteredOptions(newVal) {
			if (this.pendingScrollDir) {
				this.$nextTick(() => {
					const el = this.$refs["suggestions-dropdown"];
					if (el && el.scrollHeight > 0) el.scrollTop = el.scrollHeight * 0.5;
					this.pendingScrollDir = null;
				});
			}
			this.currentHighlightIndex = -1; // Reset highlight on filter change
		},
		suggestions(newSuggestions) {
			this.filteredOptions = (newSuggestions || []).filter(
				(option) =>
					option.toLowerCase().includes(this.currentInput.toLowerCase()) &&
					!this.inputData.includes(option)
			);
		},
		inputData(newTags, oldTags) {
			this.filteredOptions = (this.suggestions || []).filter(
				(option) => !this.inputData.includes(option)
			);
			if (this.isFocused) {
				this.showSuggestions = true;
				// Reset to default list when all tags are removed while focused
				if (newTags.length === 0 && (oldTags || []).length > 0) {
					this.$emit("reset-suggestions");
				}
			}
		},
	},
	created() {
		if (this.vmodel) {
			this.inputData = this.vmodel;
		}
	},
	methods: {
		handleTyping(event) {
			this.currentInput = event.target.value;
			this.filteredOptions = (this.suggestions || []).filter(
				(option) =>
					option.toLowerCase().includes(this.currentInput.toLowerCase()) &&
					!this.inputData.includes(option)
			);
			this.showSuggestions = true;
			this.currentHighlightIndex = -1;
			this.$emit("handle-typing", this.currentInput);
		},
		handleKeyPress(event) {
			const isDown = event.key === "ArrowDown" || event.keyCode === 40;
			const isUp = event.key === "ArrowUp" || event.keyCode === 38;
			const isEnter = event.key === "Enter" || event.keyCode === 13;

			// Allow ArrowDown to open the dropdown if it's closed
			if (!this.showSuggestions && isDown) {
				this.showSuggestions = true;
				event.preventDefault();
				event.stopPropagation();
				return;
			}

			if (!this.showSuggestions || this.filteredOptions.length === 0) return;

			if (isDown) {
				event.preventDefault();
				event.stopPropagation();
				if (this.currentHighlightIndex < this.filteredOptions.length - 1) {
					this.currentHighlightIndex++;
					this.scrollHighlightIntoView();
				}
			} else if (isUp) {
				event.preventDefault();
				event.stopPropagation();
				if (this.currentHighlightIndex > 0) {
					this.currentHighlightIndex--;
					this.scrollHighlightIntoView();
				}
			} else if (isEnter) {
				if (
					this.currentHighlightIndex >= 0 &&
					this.currentHighlightIndex < this.filteredOptions.length
				) {
					event.preventDefault();
					event.stopPropagation();
					this.selectSuggestion(
						this.filteredOptions[this.currentHighlightIndex]
					);
				}
			}
		},
		scrollHighlightIntoView() {
			this.$nextTick(() => {
				const dropdown = this.$refs["suggestions-dropdown"];
				if (dropdown) {
					// Safely filter out spinner rows to get exactly the suggestion divs
					const items = Array.from(dropdown.children).filter(
						(el) => !el.classList.contains("skill-spinner-row")
					);

					if (items[this.currentHighlightIndex]) {
						const highlightedEl = items[this.currentHighlightIndex];
						const offsetTop = highlightedEl.offsetTop;
						const offsetHeight = highlightedEl.offsetHeight;
						const dropdownScrollTop = dropdown.scrollTop;
						const dropdownHeight = dropdown.clientHeight;

						if (offsetTop < dropdownScrollTop) {
							dropdown.scrollTop = offsetTop;
						} else if (
							offsetTop + offsetHeight >
							dropdownScrollTop + dropdownHeight
						) {
							dropdown.scrollTop = offsetTop + offsetHeight - dropdownHeight;
						}
					}
				}
			});
		},
		checkValid(vals) {
			if (this.inputData.length > 0) {
				for (let i = 0; i < vals.length; i++) {
					if (
						vals[i].length > 64 ||
						(vals && vals.every((val) => val === "") && this.mandatory)
					) {
						const skillsUsedDiv = document.getElementById(this.id);
						if (!skillsUsedDiv) {
							return false;
						}
						const skillList = skillsUsedDiv.getElementsByTagName("span");
						const skillList2 = skillsUsedDiv.getElementsByTagName("li");

						for (let i = 0; i < skillList.length; i++) {
							if (
								skillList[i].classList.contains("b-form-tag-content") &&
								skillList[i].textContent.length > 64
							) {
								skillList[i].style.color = "red"; // Change the color to black
								skillList2[i].style.borderColor = "red"; // Change the border color to red
								skillList2[i].style.borderStyle = "solid"; // Ensure the border is visible (if it's not already set)
								skillList2[i].style.borderWidth = "1px";
							}
						}
					}
				}
			} else {
				this.isvalidTag = true;
				this.$forceUpdate();
			}
		},
		handleInput() {
			this.showSuggestions = true;
			this.$emit("select-value", this.inputData);
			this.$emit("handle-input");
			// Track current input text
			const inputField = this.$refs.tags?.$el.querySelector("input");
			if (inputField) {
				this.currentInput = inputField.value;
			}
			this.$nextTick(() => {
				const tagsContainer =
					this.$refs.tags.$el.querySelector(".b-form-tags-list");

				if (tagsContainer) {
					tagsContainer.scrollLeft =
						tagsContainer.scrollWidth - tagsContainer.clientWidth;
				} else {
					console.error("Tags container not found via ref");
				}
			});
		},
		handleFocusIn() {
			this.showSuggestions = true;
			this.isFocused = true;
			this.$emit("handle-focus");
			this.filteredOptions = (this.suggestions || []).filter((suggestion) => {
				return !this.inputData.some(
					(sug) => sug.toLowerCase() === suggestion.toLowerCase()
				);
			});
			this.$forceUpdate();
		},
		handleFocusOut() {
			setTimeout(() => {
				// this.showSuggestions = false;
				this.isFocused = false;
				const inputField = this.$refs.tags?.$el.querySelector("input");
				if (inputField) {
					this.currentInput = inputField.value;
				}
				this.$forceUpdate();
			}, 100);
		},
		validateTag(tag) {
			const valTag = !this.inputData.some(
				(i) => i.toLowerCase() === tag.toLowerCase()
			);
			this.isvalidTag =
				tag.trim().length > 0 && tag.trim().length < 65 && tag.trim() != "";
			// return valTag
			if (!this.isvalidTag) {
				this.$emit("changeErrStatus");
				return false;
			}
			return valTag;
		},
		onScroll(event) {
			if (this.skillLoading) return;
			const el = event.target;
			const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 20;
			const atTop = el.scrollTop <= 20;
			if (atBottom) {
				this.pendingScrollDir = "down";
				this.$emit("load-next-page");
			} else if (atTop) {
				this.pendingScrollDir = "up";
				this.$emit("load-prev-page");
			}
		},
		closeDropdownOnClickOutside(event) {
			// Check if the clicked element is not within the component
			if (
				!this.$refs["suggestions"]?.contains(event.target) &&
				!this.$refs["suggestions-dropdown"]?.contains(event.target)
			) {
				this.showSuggestions = false; // Close the dropdown
			}
		},
		closeDropdownOnFocusOut(event) {
			// Check if the focus is outside the custom select component
			if (
				!this.$refs["suggestions"]?.contains(event.target) &&
				!this.$refs["suggestions-dropdown"]?.contains(event.target)
			) {
				this.showSuggestions = false; // Close the dropdown
			}
		},
		selectSuggestion(suggestion) {
			// this.showSuggestions = false;
			const inputField = this.$refs.tags.$el.querySelector(
				".b-form-tags-list input"
			);
			if (inputField) {
				inputField.value = ""; // Clear the value
				inputField.dispatchEvent(new Event("input", { bubbles: true })); // Trigger input event
			}

			this.inputData.push(suggestion);
			this.$emit("select-value", this.inputData);
			this.$emit("update:vmodel", this.inputData);
			this.$nextTick(() => {
				const tagsContainer =
					this.$refs.tags.$el.querySelector(".b-form-tags-list");

				if (tagsContainer) {
					tagsContainer.scrollLeft =
						tagsContainer.scrollWidth - tagsContainer.clientWidth / 2;
				} else {
					console.error("Tags container not found via ref");
				}
			});
		},
	},
};
</script>

<style>
.highlighted {
	background-color: #f0f0f0 !important;
	color: #000 !important;
}
.panellist-tags .form-control:focus {
	box-shadow: unset;
}
</style>
<style>
.overflow-x-auto {
	overflow-x: hidden;
}
.customised-form-tags .b-form-tags-list .btn {
	display: block !important;
	height: 20px;
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px !important;
	color: #20639b;
	border: 1px solid #20639b;
	border-radius: 13px;
	padding: 0px 10px;
	cursor: pointer;
	margin-left: 2px;
	margin-right: 1px;
}

.customised-form-tags .b-form-tags-list .btn-outline-secondary:hover {
	background-color: unset !important;
	box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.21);
	color: #20639b;
}

.customised-form-tags
	.b-form-tags-list
	.btn-outline-secondary:not(:disabled):not(.disabled):active {
	color: #20639b;
	box-shadow: none !important;
}

.customised-form-tags .form-control {
	box-sizing: border-box;
	padding: 0px 14px;
	background: #ffffff;
	border: 1px solid #d0d5dd !important;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: #333333;
	height: 40px !important;
}

.showErrorClass .form-control {
	border: 1px solid #eb0002 !important;
}

.show-add-btn .b-form-tags-list .btn {
	visibility: unset !important;
	pointer-events: all !important;
	opacity: 1 !important;
}

.customised-form-tags .b-form-tags .form-control {
	height: 36px !important;
}

.customised-form-tags div ul {
	flex-wrap: nowrap !important;
	overflow-y: hidden;
	overflow-x: auto;
	height: 100%;
	margin-top: unset !important;
	width: 261px;
}

@media (max-width: 1028px) {
	.tags-mobile-suggestion::-webkit-scrollbar {
		width: 5px !important;
		height: 5px !important;
	}
	.customised-form-tags div ul {
		width: 100%;
	}
}

.customised-form-tags .badge-secondary {
	background-color: #f1f7ff;
	border-radius: 15px;
	padding: 4px 10px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #20639b;
}

.customised-form-tags .b-form-tag > button.b-form-tag-remove {
	color: inherit;
	font-size: 101%;
	line-height: 1;
	padding: 0px 2.5px;
	float: none;
	top: 0;
	margin-left: 0.25rem;
	color: #20639b;
}

.customised-form-tags .b-form-tags .b-form-tags-list input::placeholder {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #667085;
	opacity: 1;
}

.customised-form-tags .b-form-tags .b-form-tags-list .b-from-tags-field {
	margin-top: 0px;
}

.customised-form-tags .b-form-tags-list .b-form-tags-field,
.b-form-tags-list .b-form-tag {
	margin-top: 0;
}

.customised-form-tags .text-muted {
	position: absolute;
	left: 0;
	color: red !important;
	bottom: -21px;
	font-size: 11px !important;
	font-weight: 500 !important;
	width: 100%;
	word-break: break-all;
}

.customised-form-tags .invalid-feedback {
	position: absolute !important;
	left: 0 !important;
	color: red !important;
	bottom: -21px !important;
	font-size: 11px !important;
	font-weight: 500 !important;
}

.customised-form-tags .b-form-tag > button.b-form-tag-remove {
	border: 1px solid #20639b;
	border-radius: 13px;
	height: 13px;
	font-size: 101%;
	line-height: 1;
	padding: 0px 2.5px;
	float: none;
	opacity: 1;
	margin-left: 10px;
	color: #20639b;
}
</style>
